import AuthMemberInfo from './OTPVerification';

export default AuthMemberInfo;
